import data from "../../../../../src/Select/Select.docs.json";
import { Select, Text } from '@primer/react';
import * as React from 'react';
export default {
  data,
  Select,
  Text,
  React
};